import React from "react"

export default function WelComePage() {
  return (
    <div className="flex h-full w-full items-center justify-center text-center text-[24px] font-semibold leading-[30px] text-black">
      {"Welcome to Payment"}
    </div>
  )
}
